import * as React from "react";

import { cn } from "src/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(({ className, type, ...props }, ref) => (
	<input
		type={type}
		ref={ref}
		className={cn(
			"tw-flex tw-h-11 tw-w-full tw-rounded-[10px] tw-border tw-border-border tw-bg-white tw-px-3 tw-py-2 tw-text-[14px] tw-text-text tw-transition-colors",
			"file:tw-border-0 file:tw-bg-transparent file:tw-text-sm file:tw-font-medium placeholder:tw-text-text-soft",
			"focus-visible:tw-outline-none focus-visible:tw-border-teal focus-visible:tw-ring-2 focus-visible:tw-ring-teal/20",
			"disabled:tw-cursor-not-allowed disabled:tw-bg-slate-tint disabled:tw-opacity-60",
			className
		)}
		{...props}
	/>
));
Input.displayName = "Input";

export { Input };
